import { createSelector } from '@reduxjs/toolkit';
import { GlobalState } from 'types/state';

export const selectClippPricingUrls = createSelector(
  (state: GlobalState) => state.clippPricingUrls,
  (clippPricingUrls) => clippPricingUrls,
);
